import { getCompanyContracts, getCompanyContractSections, getCompanyContractSectionCategories, getContractTemplates, getContractTitles } from "@/helpers/api/contracts"
const listingColumns = localStorage.getItem('contracts_columns')

const ChatStore = {
  namespaced: true,
  state: {
		listingColumns: listingColumns ? JSON.parse(listingColumns):{
			serial: true,
			client: true,
			details: true,
			address: true,
			status: true,
			actions: true
		},
		loadingCompanyContractsList: false,
		companyContractsList: [],
		companyContractsLastId: null,
		companyContractsListCount: 0,
		loadingCompanyContracts: false,
		companyContracts: [],
		loadingCompanyContractCategories: false,
		companyContractCategories: [],
		modalCategory: false,
		modalCategoryEditing: null,
		modalSection: false,
		modalSectionEditing: null,
		modalContract: false,
		modalContractInfo: null,
		loadingTemplateContracts: false,
		templateContracts: [],
		loadingTitleContracts: false,
		titleContracts: [],
		loadingSubtitleContracts: false,
		subtitleContracts: [],
		contractEditorRef: null,
		contractPdfModal: null,
		contractSignModal: null,
		scrolledContract: 0,
		contractHeaderHeight: 0,
		contractSecondHeaderHeight: 0,
		contractModalId: false,
		contractModalInfo: null,
		contractAddendumModalId: false,
		contractAddendumModalInfo: null,
		contractComponentModalId: null,
		subcontractComponentModalId: null,
		contractAddendumComponentModalId: null,
		newContractTitleModal: false,
		newContractTitleModalEditing: null,
		subcontractContractorModalId: null
  },
  mutations: {
    setListingColumns(state, listingColumns) {
      state.listingColumns = listingColumns
			localStorage.setItem('reports_columns', JSON.stringify(listingColumns))
    },
		setScrolledContract(state, value) {
			state.scrolledContract = value
		},
		setContractHeaderHeight(state, value) {
			state.contractHeaderHeight = value
		},
		setContractSecondHeaderHeight(state, value) {
			state.contractSecondHeaderHeight = value
		},
    setLoadingCompanyContractsList(state, status) {
      state.loadingCompanyContractsList = status
    },
    setLoadingCompanyContractsListCount(state, count) {
      state.companyContractsListCount = count
    },
    setCompanyContractsList(state, companyContracts) {
      state.companyContractsList = companyContracts
    },
    setCompanyContractsLastId(state, contract_id) {
      state.companyContractsLastId = contract_id
    },
    setLoadingCompanyContracts(state, status) {
      state.loadingCompanyContracts = status
    },
    setCompanyContracts(state, companyContracts) {
      state.companyContracts = companyContracts
    },
    setLoadingTitleContracts(state, status) {
      state.loadingTitleContracts = status
    },
    setTitleContracts(state, titles) {
      state.titleContracts = titles
    },
    setLoadingSubtitleContracts(state, status) {
      state.loadingSubtitleContracts = status
    },
    setSubtitleContracts(state, titles) {
      state.subtitleContracts = titles
    },
    setLoadingTemplateContracts(state, status) {
      state.loadingTemplateContracts = status
    },
    setTemplateContracts(state, templates) {
      state.templateContracts = templates
    },
    setLoadingCompanyContractCategories(state, status) {
      state.loadingCompanyContractCategories = status
    },
    setCompanyContractCategories(state, cats) {
      state.companyContractCategories = cats
    },
    setModalCategory(state, status) {
      state.modalCategory = status
    },
    setModalCategoryEditing(state, value) {
      state.modalCategoryEditing = value
    },
    setModalSection(state, status) {
      state.modalSection = status
    },
    setModalSectionEditing(state, value) {
      state.modalSectionEditing = value
    },
    setModalContract(state, status) {
      state.modalContract = status
    },
    setModalContractInfo(state, status) {
      state.modalContractInfo = status
    },
    setContractEditorRef(state, ref) {
      state.contractEditorRef = ref
    },
		setContractPdfModal(state, pdf) {
			state.contractPdfModal = pdf
		},
		setContractSignModal(state, contract) {
			state.contractSignModal = contract
		},
		setContractModalId(state, value) {
			state.contractModalId = value
		},
		setContractModalInfo(state, value) {
			state.contractModalInfo = value
		},
		setContractAddendumModalId(state, value) {
			state.contractAddendumModalId = value
		},
		setContractAddendumModalInfo(state, value) {
			state.contractAddendumModalInfo = value
		},
		setContractComponentModalId(state, value) {
			state.contractComponentModalId = value
		},
		setSubcontractComponentModalId(state, value) {
			state.subcontractComponentModalId = value
		},
		setContractAddendumComponentModalId(state, value) {
			state.contractAddendumComponentModalId = null
			setTimeout(() => {
				state.contractAddendumComponentModalId = value
			}, 50);
		},
		setNewContractTitleModal(state, value){
			state.newContractTitleModal = value
		},
		setNewContractTitleModalEditing(state, value){
			state.newContractTitleModalEditing = value
		},
		setSubcontractContractorModalId(state, value) {
			state.subcontractContractorModalId = value
		}
  },
  actions: {
    async getContracts({ commit }, {search = null, start = 0, limit = 20, contract_type = null, order_by = 1} = {}) {
			start = isNaN(start) ? 0 : start
      commit('setLoadingCompanyContractsList', true)
      const data = {
				search,
        start,
        limit,
				contract_type,
				order_by
      }
      const contracts = await getCompanyContracts(data)
      if (contracts.code === 200) {

				commit('setCompanyContractsList', contracts.contracts)
				commit('setCompanyContractsLastId', contracts.last_contract_id)
				commit('setLoadingCompanyContractsListCount', contracts.contracts_count)
				commit('setLoadingCompanyContractsList', false)

        // commit('setCompanyContractsList', [])
				// setTimeout(() => {
				// 	commit('setCompanyContractsList', contracts.contracts)
				// 	commit('setCompanyContractsLastId', contracts.last_contract_id)
				// 	commit('setLoadingCompanyContractsListCount', contracts.contracts_count)
				// 	commit('setLoadingCompanyContractsList', false)
				// }, 50);
      }
			else{
				commit('setLoadingCompanyContractsList', false)
			}
    },
    async getCompanyContractsConfig({ commit }, data) {
      commit('setLoadingCompanyContracts', true)
      const section = await getCompanyContractSections(data)
      if (section.code === 200) {
        commit('setCompanyContracts', section.contract_sections)
      }
      commit('setLoadingCompanyContracts', false)
    },
    async getContractTemplates({ commit }, data) {
      commit('setLoadingTemplateContracts', true)
      const templates = await getContractTemplates(data)
      if (templates.code === 200) {
        commit('setTemplateContracts', templates.contracts)
      }
      commit('setLoadingTemplateContracts', false)
    },
    async getContractTitles({ commit }, data) {
      commit('setLoadingTitleContracts', true)
      const titles = await getContractTitles(data)
      if (titles.code === 200) {
        commit('setTitleContracts', titles.company_contract_titles)
        commit('setSubtitleContracts', titles.company_contract_subtitles)
      }
      commit('setLoadingTitleContracts', false)
    },
    async getCompanyContractCategoriesConfig({ commit }, data) {
      commit('setLoadingCompanyContractCategories', true)
      const categories = await getCompanyContractSectionCategories(data)
      if (categories.code === 200) {
        commit('setCompanyContractCategories', categories.contract_categories)
      }
      commit('setLoadingCompanyContractCategories', false)
    }
  }
}

export default ChatStore
